export default {
  isInProgress (state) {
    return state.isStarting || state.status === 'queued' || state.status === 'running'
  },
  isSucceeded (state) {
    return state.status === 'succeeded'
  },
  hasFailed (state) {
    return state.status === 'failed'
  }
}
